import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getData } from '../Services/api';
import Pagination from '../Services/Pagination';

const VisitLog = () => {
  const [visits, setVisits] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);

  const [filters, setFilters] = useState({
    customerId: '',
    customerName: '',
    dateFrom: '',
    dateTo: ''
  });

  const { id } = useParams(); // userId from URL

  const fetchVisits = async (pageNumber = page) => {
    try {
      // Build query string dynamically
      const query = new URLSearchParams({
        userId: id,
        page: pageNumber,
        limit: 10,
        ...filters
      }).toString();

      const res = await getData(`/visits/all?${query}`);
      if (res.status) {
        setVisits(res.visits || []);
        setPage(res.currentPage || 1);
        setPages(res.totalPages || 1);
        setTotal(res.totalRecords || 0);
      }
    } catch (error) {
      console.log('Error fetching visits:', error);
    }
  };

  useEffect(() => {
    fetchVisits();
  }, [page, filters, id]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber !== page) {
      fetchVisits(pageNumber);
    }
  };

  return (
    <div className="pc-container">
      <div className="pc-content">
        {/* Header */}
        <div className="page-header">
          <div className="page-block">
            <div className="row align-items-center">
              <div className="col-md-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item" aria-current="page">
                    Visit Log
                  </li>
                </ul>
              </div>
              <div className="col-md-12">
                <div className="page-header-title">
                  <h2 className="mb-0">Visit Log</h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="row mb-3 px-4">
          <div className="col-md-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search Customer Name"
              value={filters.customerName}
              onChange={(e) => setFilters({ ...filters, customerName: e.target.value })}
            />
          </div>
          <div className="col-md-3">
            <input
              type="date"
              className="form-control"
              value={filters.dateFrom}
              onChange={(e) => setFilters({ ...filters, dateFrom: e.target.value })}
            />
          </div>
          <div className="col-md-3">
            <input
              type="date"
              className="form-control"
              value={filters.dateTo}
              onChange={(e) => setFilters({ ...filters, dateTo: e.target.value })}
            />
          </div>
        </div>

        {/* Table */}
        <div className="row">
          <div className="col-sm-12">
            <div className="card table-card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-hover" id="pc-dt-simple">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Customer Name</th>
                        <th>Check-In</th>
                        <th>Check-Out</th>
                        <th>Notes</th>
                        <th>Visited</th>
                      </tr>
                    </thead>
                    <tbody>
                      {visits.length > 0 ? (
                        visits.map((visit, index) => (
                          <tr key={visit.id}>
                            <td>{index + 1 + (page - 1) * 10}</td>
                            <td>{visit.displayName || 'Unknown'}</td>
                            <td>
                              {visit.checkInAt
                                ? new Date(visit.checkInAt).toLocaleString("en-GB", {
                                  timeZone: "Africa/Dar_es_Salaam",
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit"
                                })
                                : "N/A"}
                            </td>

                            <td>
                              {visit.updatedAt
                                ? new Date(visit.updatedAt).toLocaleString("en-GB", {
                                  timeZone: "Africa/Dar_es_Salaam",
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit"
                                })
                                : "N/A"}
                            </td>
                            <td>{visit.notes || '-'}</td>
                            <td>{visit.visited ? 'Yes' : 'No'}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="text-center" colSpan={6}>
                            <strong>No Visits Found.</strong>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                  <div className="text-muted">
                    Showing {(page - 1) * 10 + 1} to {Math.min(page * 10, total)} of {total} entries
                  </div>
                  <Pagination page={page} pages={pages} onPageChange={handlePageChange} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisitLog;
